// @flow
import * as React from 'react'

export const VariablesContext = React.createContext()

export default function useVariables () {
  const context = React.useContext(VariablesContext)
  return context
}